// The weekly review's schedule, as the settings screens read and write it
// (CER-85). One place names the days, so web and mobile offer the same list in
// the same order as Postgres numbers them (EXTRACT(DOW): 0 is Sunday), which
// is what private.queue_weekly_reviews stores in profiles.weekly_review_day.

import { formatClockTime } from './clock.ts';

/** Day names by their Postgres day-of-week number, Sunday first. */
export const WEEKDAY_NAMES = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const;

/**
 * The day the weekly review arrives on when the person has not chosen one: a
 * Sunday evening, before the week it looks ahead into. profiles' defaults are
 * the same day and time, so the two never disagree.
 */
export const WEEKLY_REVIEW_DEFAULT_DAY = 0;
export const WEEKLY_REVIEW_DEFAULT_TIME = '17:00';

/** `day` is a day the weekly review can be set to: a whole 0..6, or null (off). */
export function isWeeklyReviewDay(day: unknown): day is number | null {
  return day === null || (typeof day === 'number' && Number.isInteger(day) && day >= 0 && day <= 6);
}

/**
 * The settings line for a weekly review: "Sunday at 17:00", or that it is off.
 * `time` is the profile's weekly_review_time, "HH:MM" or "HH:MM:SS".
 */
export function weeklyReviewSummary(day: number | null, time: string): string {
  if (day === null) return 'Off';
  return `${WEEKDAY_NAMES[day]} at ${formatClockTime(time)}`;
}
